const SUBSCRIPTIONS = Object.freeze({
    base: {
        amount: 700,
        displayAmount: 7.00,
    },
});

const ADD_ONS = Object.freeze([
    {
        id: "0",
        name: "File Upload",
        description: "Upload files to the workspace.",
        amount: 299,
        defaultEnabled: true,
    },
    {
        id: "1",
        name: "Auto Engage",
        description: "Automatically engage with visitors.",
        amount: 0,
        defaultEnabled: true,
    },
    {
        id: "2",
        name: "Auto Reply",
        description: "Automatically reply to messages.",
        amount: 0,
        defaultEnabled: true,
    },
    {
        id: "3",
        name: "Contact Info Module",
        description: "Display contact information.",
        amount: 0,
        defaultEnabled: true,
    },
]);

export { SUBSCRIPTIONS, ADD_ONS };